// Every one of these URLs shows the home page and scrolls to the matching section.
// Keys are lower-case; the value is the id of the section on the page (null = top).
export const HOME_SECTIONS = {
  "/": null,
  "/features": "features",
  "/activities": "activities",
  "/testimonial": "testimonials",
  "/gallery": "gallery",
  "/faq": "faq",
  "/admission": "admission",
};

// Paths as registered with the router (case-insensitive match).
export const HOME_PATHS = [
  "/",
  "/Features",
  "/Activities",
  "/Testimonial",
  "/Gallery",
  "/Faq",
  "/Admission",
];
